import { useEffect, useRef, useState } from "react";

type CapFrame = {
  src: string;
  label: string;
};

type LegalPanel = "legal" | "privacy" | null;

const lifestyleImages = [
  "/assets/lifestyle-01.jpg",
  "/assets/lifestyle-02.jpg",
  "/assets/lifestyle-03.jpg",
];

const frames: CapFrame[] = [
  { src: "/assets/cap-front.png", label: "FRONT" },
  { src: "/assets/cap-left.png", label: "LEFT" },
  { src: "/assets/cap-back.png", label: "BACK" },
  { src: "/assets/cap-right.png", label: "RIGHT" },
];

const detailPartOne =
  "The best part of the night isn't the party. It's the pregame";

const detailPartTwo =
  ". It's your friends, your drinks, that vibe before you step out.\n\n";

const detailPartThree = " is the moment.";

const detailTypingLength =
  detailPartOne.length +
  1 +
  detailPartTwo.length +
  1 +
  detailPartThree.length;

const styles = `
:root {
  --blue: #1b1464;
  --paper: #ffffff;
  --line: rgba(27, 20, 100, 0.15);
  --muted: rgba(27, 20, 100, 0.58);
  --max: 1110px;
}

* {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
  background: var(--paper);
}

body {
  margin: 0;
  min-width: 320px;
  background: var(--paper);
  color: var(--blue);
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  text-rendering: geometricPrecision;
}

a {
  color: inherit;
  text-decoration: none;
}

button,
input {
  font: inherit;
}

img {
  display: block;
  max-width: 100%;
}

.site {
  min-height: 100vh;
  background: #fff;
}



.mono {
  font-family: "Courier New", Courier, monospace;
  font-size: 13px;
  line-height: 1.55;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.micro {
  margin: 0;
  color: var(--muted);
}



.site {
  --hero-progress: 0;
}

.reveal,
.assemble {
  opacity: 0;
  will-change: opacity, transform;
  transition:
    opacity 850ms cubic-bezier(.22,.7,.18,1),
    transform 950ms cubic-bezier(.22,.7,.18,1);
}

.reveal-left {
  transform: translateX(-82px);
}

.reveal-right {
  transform: translateX(82px);
}

.reveal-up {
  }

.assemble {
  }

.reveal.is-visible,
.assemble.is-visible {
  opacity: 1;
  transform: translate(0, 0) scale(1);
}

.reveal-delay-1 {
  transition-delay: 90ms;
}

.reveal-delay-2 {
  transition-delay: 180ms;
}

.reveal-delay-3 {
  transition-delay: 270ms;
}

.reveal-delay-4 {
  transition-delay: 360ms;
}

@media (prefers-reduced-motion: reduce) {
  .reveal,
  .assemble {
    opacity: 1 !important;
    transform: none !important;
  }
}



.header {
  position: fixed;
  z-index: 50;
  top: 0;
  left: 0;
  right: 0;
  height: 88px;
  padding: 0 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(27, 20, 100,
    clamp(0, calc((var(--hero-progress) - .18) * .9), .15));
  background: rgba(255, 255, 255,
    clamp(0, calc((var(--hero-progress) - .12) * 1.35), .96));
  backdrop-filter: blur(12px);
  opacity: clamp(0, calc((var(--hero-progress) - .16) * 2.25), 1);
    transition: opacity 120ms linear, transform 120ms linear;
  pointer-events: none;
}

.header .turtle-home,
.header .nav {
  pointer-events: auto;
}

.turtle-home {
  width: 48px;
  height: 48px;
  display: grid;
  place-items: center;
}

.turtle-home img {
  width: 48px;
  height: 48px;
  object-fit: contain;
}

.nav {
  display: flex;
  align-items: center;
  gap: 30px;
}

.nav a {
  position: relative;
  font-size: 12px;
  line-height: 1;
  letter-spacing: 0.14em;
}

.nav a::after,
.footer-links a::after {
  content: "";
  position: absolute;
  left: 0;
  right: 100%;
  bottom: -6px;
  height: 1px;
  background: var(--blue);
  transition: right 180ms ease;
}

.nav a:hover::after,
.footer-links a:hover::after {
  right: 0;
}



.hero {
  position: relative;
  min-height: 165svh;
  padding-top: 0;
  overflow: clip;
  border-bottom: 1px solid var(--line);
}

.hero-content {
  position: sticky;
  top: 0;
  width: min(94vw, 820px);
  min-height: 100svh;
  margin: 0 auto;
  padding: 100px 20px 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.hero-brand-stage {
  position: relative;
  width: min(78vw, 650px);
  height: min(54vw, 390px);
  min-height: 300px;
  display: grid;
  place-items: center;
}

.hero-turtle-large,
.wordmark {
  grid-area: 1 / 1;
}

.hero-turtle-large {
  width: min(42vw, 330px);
  min-width: 230px;
  height: auto;
  opacity: clamp(0, calc(1 - var(--hero-progress) * 1.55), 1);
    filter: blur(calc(var(--hero-progress) * 3px));
  transition: opacity 80ms linear;
}

.wordmark {
  width: min(52vw, 500px);
  min-width: 300px;
  height: auto;
  opacity: clamp(0, calc((var(--hero-progress) - .36) * 2.2), 1);
    filter: blur(calc((1 - var(--hero-progress)) * 7px));
  transition: opacity 80ms linear;
}

.hero-location,
.tagline,
.primary-button {
  opacity: clamp(0, calc((var(--hero-progress) - .48) * 2.2), 1);
  }

.hero-location {
  margin-bottom: 6px;
}

.tagline {
  margin-top: 6px;
  color: var(--blue);
}

.primary-button {
  margin-top: 32px;
  min-width: 138px;
  height: 44px;
  padding: 0 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--blue);
  background: var(--blue);
  color: #fff;
  font-family: "Courier New", Courier, monospace;
  font-size: 12px;
  line-height: 1;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  transition: background 180ms ease, color 180ms ease;
}

.primary-button:hover {
  background: #fff;
  color: var(--blue);
}



.ticker {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 82px;
  display: flex;
  align-items: center;
  overflow: hidden;
  border-top: 1px solid var(--line);
  background: #fff;
  opacity: clamp(0, calc((var(--hero-progress) - .68) * 3), 1);
  }

.ticker-track {
  display: flex;
  flex-shrink: 0;
  width: max-content;
  min-width: 200vw;
  align-items: center;
  white-space: nowrap;
  will-change: transform;
  animation: tickerMove 30s linear infinite;
}

.ticker-group {
  display: flex;
  flex-shrink: 0;
  min-width: 100vw;
  align-items: center;
  justify-content: space-around;
}

.ticker-group span {
  display: inline-block;
  padding-right: 42px;
  color: rgba(27, 20, 100, 0.48);
  font-family: "Courier New", Courier, monospace;
  font-size: 12px;
  line-height: 1;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

@keyframes tickerMove {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50%);
  }
}



.product-section {
  padding: 138px 24px 150px;
}

.shell {
  width: min(100%, var(--max));
  margin: 0 auto;
}

.section-title {
  margin: 0 0 64px 18px;
}

.section-title h1,
.purchase h2,
.statement h3 {
  margin: 0;
  color: var(--blue);
  font-weight: 400;
  letter-spacing: -0.055em;
}

.section-title h1 {
  margin-top: 20px;
  font-size: clamp(60px, 6vw, 88px);
  line-height: 0.91;
}

.product-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.55fr) minmax(270px, 0.75fr);
  border-top: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
}

.viewer {
  min-height: 625px;
  display: grid;
  grid-template-rows: 50px 1fr 50px;
  border-right: 1px solid var(--line);
  outline: none;
  cursor: ew-resize;
  touch-action: pan-y;
}

.viewer:focus-visible {
  box-shadow: inset 0 0 0 1px var(--blue);
}

.viewer-bar {
  padding: 0 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  color: var(--muted);
  font-family: "Courier New", Courier, monospace;
  font-size: 11px;
  line-height: 1.2;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.viewer-bar:first-child {
  border-bottom: 1px solid var(--line);
}

.viewer-bar:last-child {
  border-top: 1px solid var(--line);
}

.cap-stage {
  display: grid;
  place-items: center;
  overflow: hidden;
  background: #fff;
}

.cap-image {
  width: 94%;
  height: 500px;
  object-fit: contain;
  user-select: none;
  pointer-events: none;
  transform-origin: center;
  animation: capIn 180ms ease both;
}

@keyframes capIn {
  from {
    opacity: 0.78;
    transform: scale(0.988);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

.purchase {
  min-width: 0;
  padding: 46px 28px 34px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.purchase h2 {
  margin-top: 17px;
  font-size: clamp(48px, 4.3vw, 66px);
  line-height: 0.92;
}

.price {
  margin: 18px 0 0;
  font-size: 22px;
  letter-spacing: -0.03em;
}

.shipping-note {
  margin: 7px 0 0;
  color: var(--muted);
  font-family: "Courier New", Courier, monospace;
  font-size: 10px;
  line-height: 1.4;
  letter-spacing: 0.09em;
  text-transform: uppercase;
}


.specs {
  margin-top: 48px;
  border-top: 1px solid var(--line);
}

.specs > div {
  min-height: 54px;
  padding: 12px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  border-bottom: 1px solid var(--line);
  font-family: "Courier New", Courier, monospace;
  font-size: 11px;
  line-height: 1.4;
  letter-spacing: 0.09em;
  text-transform: uppercase;
}

.specs span {
  color: var(--muted);
}

.specs strong {
  max-width: 180px;
  color: var(--blue);
  font-weight: 400;
  text-align: right;
}

.buy-button {
  margin-top: 30px;
  width: 100%;
  min-height: 54px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid var(--blue);
  background: var(--blue);
  color: #fff;
  cursor: pointer;
  font-family: "Courier New", Courier, monospace;
  font-size: 12px;
  line-height: 1.2;
  letter-spacing: 0.11em;
  text-transform: uppercase;
  transition: background 180ms ease, color 180ms ease;
}

.buy-button:hover {
  background: #fff;
  color: var(--blue);
}

.fineprint {
  margin: 14px 0 0;
  color: var(--muted);
  font-family: "Courier New", Courier, monospace;
  font-size: 10px;
  line-height: 1.6;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}




.lookbook-section {
  padding: 0 0 150px;
  background: #fff;
}

.lookbook-heading {
  width: min(100% - 48px, var(--max));
  margin: 0 auto 28px;
}

.lookbook-viewport {
  width: 100%;
  min-height: 610px;
  display: grid;
  place-items: center;
  overflow: hidden;
  border-top: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  background: #fff;
}

.lookbook-grid {
  width: min(calc(100% - 48px), 1320px);
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 22px;
  align-items: center;
  justify-content: center;
}

.lookbook-card {
  position: relative;
  margin: 0;
  height: 530px;
  overflow: hidden;
  background: #f7f7f7;
  border: 1px solid var(--line);
  opacity: 0;
    transition:
    transform 220ms ease,
    opacity 220ms ease,
    box-shadow 220ms ease;
}

.lookbook-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  user-select: none;
  pointer-events: none;
}


.lookbook-card:nth-child(1) {
  animation: lookbookLeft 9s ease-in-out infinite;
}

.lookbook-card:nth-child(2) {
  animation: lookbookMiddle 9s ease-in-out infinite;
}

.lookbook-card:nth-child(3) {
  animation: lookbookRight 9s ease-in-out infinite;
}

@keyframes lookbookLeft {
  0%, 4% {
    opacity: 0;
      }

  5%, 56% {
    opacity: 1;
      }

  57%, 100% {
    opacity: 0;
      }
}

@keyframes lookbookMiddle {
  0%, 12% {
    opacity: 0;
      }

  13%, 68% {
    opacity: 1;
      }

  69%, 100% {
    opacity: 0;
      }
}

@keyframes lookbookRight {
  0%, 20% {
    opacity: 0;
      }

  21%, 80% {
    opacity: 1;
      }

  81%, 100% {
    opacity: 0;
      }
}


.lookbook-section:not(.is-visible) .lookbook-card {
  animation-play-state: paused;
}

.lookbook-section.is-visible .lookbook-card {
  animation-play-state: running;
}


.lookbook-grid:hover .lookbook-card {
  animation-play-state: paused;
}

.lookbook-card:hover {
  z-index: 3;
  opacity: 1 !important;
  transform: scale(1.035) !important;
  box-shadow: 0 18px 50px rgba(27, 20, 100, 0.10);
}



.statement-section {
  padding: 0 24px 150px;
}

.statement {
  min-height: 500px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-top: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
}

.statement-panel {
  min-width: 0;
  padding: 72px 42px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.statement-panel:first-child {
  border-right: 1px solid var(--line);
}

.statement h3 {
  margin-top: 20px;
  font-size: clamp(52px, 5vw, 78px);
  line-height: 0.92;
}

.typewriter-shell {
  width: min(100%, 470px);
  min-height: 235px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.typewriter-text {
  margin: 0;
  width: 100%;
  color: var(--blue);
  font-size: 18px;
  line-height: 1.62;
  letter-spacing: -0.015em;
  text-align: center;
  white-space: pre-line;
}

.inline-pregame-wordmark {
  display: inline-block !important;
  width: auto;
  height: 28px;
  max-width: none;
  margin: 0 5px;
  vertical-align: -7px;
  object-fit: contain;
}

.statement-wordmark {
  width: min(100%, 330px);
  height: auto;
  margin-top: 22px;
  object-fit: contain;
}


.typewriter-cursor {
  display: inline-block;
  width: 1px;
  height: 1.08em;
  margin-left: 3px;
  vertical-align: -0.12em;
  background: var(--blue);
  animation: cursorBlink 800ms steps(1) infinite;
}

@keyframes cursorBlink {
  0%, 48% {
    opacity: 1;
  }

  49%, 100% {
    opacity: 0;
  }
}



.footer {
  min-height: 138px;
  padding: 0 38px;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 22px;
  border-top: 1px solid var(--line);
  color: var(--muted);
  font-family: "Courier New", Courier, monospace;
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: 0.09em;
  text-transform: uppercase;
}

.footer img {
  width: 30px;
  height: 30px;
  object-fit: contain;
  opacity: 0.23;
}

.footer-links {
  display: flex;
  gap: 26px;
}

.footer-links a,
.footer-link-button {
  position: relative;
}

.footer-link-button {
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  letter-spacing: inherit;
  text-transform: inherit;
}

.footer-link-button::after {
  content: "";
  position: absolute;
  left: 0;
  right: 100%;
  bottom: -6px;
  height: 1px;
  background: var(--blue);
  transition: right 180ms ease;
}

.footer-link-button:hover::after {
  right: 0;
}

.footer > span {
  justify-self: end;
}




.legal-overlay {
  position: fixed;
  z-index: 200;
  inset: 0;
  padding: 24px;
  display: grid;
  place-items: center;
  background: rgba(27, 20, 100, 0.18);
  backdrop-filter: blur(8px);
}

.legal-dialog {
  position: relative;
  width: min(100%, 820px);
  max-height: min(86vh, 900px);
  overflow: auto;
  padding: 50px 52px;
  border: 1px solid var(--line);
  background: #fff;
  color: var(--blue);
  box-shadow: 0 30px 90px rgba(27, 20, 100, 0.16);
}

.legal-close {
  position: sticky;
  z-index: 2;
  top: 0;
  margin-left: auto;
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  border: 1px solid var(--blue);
  background: #fff;
  color: var(--blue);
  cursor: pointer;
  font-size: 22px;
  line-height: 1;
}

.legal-kicker {
  margin-top: 12px;
}

.legal-dialog h4 {
  margin: 14px 0 28px;
  font-size: clamp(42px, 5vw, 66px);
  line-height: .95;
  font-weight: 400;
  letter-spacing: -.05em;
}

.legal-dialog h5 {
  margin: 30px 0 10px;
  font-size: 18px;
  font-weight: 500;
}

.legal-dialog p,
.legal-dialog li {
  font-size: 15px;
  line-height: 1.62;
}

.legal-dialog ul {
  padding-left: 20px;
}

.legal-placeholder {
  margin: 24px 0;
  padding: 18px;
  border: 1px solid var(--blue);
  font-family: "Courier New", Courier, monospace;
  font-size: 12px;
  line-height: 1.55;
  letter-spacing: .04em;
}

.legal-note {
  margin-top: 34px;
  padding-top: 20px;
  border-top: 1px solid var(--line);
  color: var(--muted);
  font-size: 13px;
  line-height: 1.55;
}

body:has(.legal-overlay) {
  overflow: hidden;
}



.toast {
  position: fixed;
  z-index: 100;
  right: 20px;
  bottom: 20px;
  padding: 15px 17px;
  background: var(--blue);
  color: #fff;
  font-family: "Courier New", Courier, monospace;
  font-size: 11px;
  line-height: 1.35;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  opacity: 0;
    pointer-events: none;
  transition: opacity 180ms ease, transform 180ms ease;
}

.toast.visible {
  opacity: 1;
  }



@media (max-width: 850px) {
  .product-grid,
  .statement {
    grid-template-columns: 1fr;
  }

  .viewer {
    border-right: 0;
    border-bottom: 1px solid var(--line);
  }

  .statement-panel:first-child {
    border-right: 0;
    border-bottom: 1px solid var(--line);
  }

  .statement-panel {
    min-height: 330px;
  }
}




@media (max-width: 980px) {
  .header {
    height: 72px;
    padding: 0 18px;
  }

  .turtle-home,
  .turtle-home img {
    width: 38px;
    height: 38px;
  }

  .hero {
    padding-top: 72px;
  }

  .hero-content {
    width: min(92vw, 680px);
    padding: 80px 18px 150px;
  }

  .wordmark {
    width: min(72vw, 500px);
  }

  .product-section {
    padding: 105px 18px 120px;
  }

  .section-title {
    margin: 0 0 44px 4px;
  }

  .product-grid {
    grid-template-columns: 1fr;
  }

  .viewer {
    border-right: 0;
    border-bottom: 1px solid var(--line);
  }

  .purchase {
    padding: 42px 24px 34px;
  }

  .statement {
    grid-template-columns: 1fr;
  }

  .statement-panel:first-child {
    border-right: 0;
    border-bottom: 1px solid var(--line);
  }

  .statement-panel {
    min-height: 320px;
  }

  .footer {
    grid-template-columns: 1fr;
    gap: 22px;
    justify-items: center;
    text-align: center;
    padding: 30px 18px;
  }

  .footer > span {
    justify-self: center;
  }
}



@media (max-width: 560px) {
  .header {
    height: 66px;
    padding: 0 14px;
  }

  .turtle-home,
  .turtle-home img {
    width: 36px;
    height: 36px;
  }

  .nav {
    gap: 14px;
  }

  .nav a {
    min-height: 44px;
    display: inline-flex;
    align-items: center;
    font-size: 10px;
    letter-spacing: 0.11em;
  }

  .mono {
    font-size: 10px;
    line-height: 1.5;
    letter-spacing: 0.10em;
  }

  .reveal-left {
    transform: translateX(-42px);
  }

  .reveal-right {
    transform: translateX(42px);
  }

  .reveal-up {
      }

  .hero {
    min-height: 155svh;
    padding-top: 0;
  }

  .hero-content {
    top: 0;
    width: 100%;
    min-height: 100svh;
    padding: 82px 18px 130px;
  }

  .hero-brand-stage {
    width: 92vw;
    height: 390px;
    min-height: 0;
  }

  .hero-turtle-large {
    width: min(58vw, 255px);
    min-width: 190px;
  }

  .hero-location {
    margin-bottom: 4px;
    text-align: center;
  }

  .wordmark {
    width: min(88vw, 420px);
    min-width: 0;
  }

  .tagline {
    margin-top: 4px;
    max-width: 90vw;
  }

  .primary-button {
    margin-top: 26px;
    min-width: 150px;
    height: 48px;
    font-size: 11px;
  }

  .ticker {
    height: 64px;
  }

  .ticker-track {
    animation-duration: 25s;
  }

  .ticker-group span {
    padding-right: 30px;
    font-size: 10px;
    letter-spacing: 0.10em;
  }

  .product-section {
    padding: 84px 14px 96px;
  }

  .section-title {
    margin: 0 0 34px 0;
  }

  .section-title h1 {
    margin-top: 14px;
    font-size: clamp(50px, 15vw, 68px);
    line-height: .92;
  }

  .product-grid {
    display: block;
  }

  .viewer {
    min-height: 430px;
    grid-template-rows: 46px 1fr 46px;
    border-right: 0;
    border-bottom: 1px solid var(--line);
  }

  .viewer-bar {
    padding: 0 12px;
    font-size: 8px;
    letter-spacing: .08em;
  }

  .cap-stage {
    min-height: 330px;
  }

  .cap-image {
    width: 100%;
    height: 330px;
    padding: 8px;
  }

  .purchase {
    padding: 34px 16px 28px;
  }

  .purchase h2 {
    margin-top: 13px;
    font-size: 48px;
  }

  .price {
    font-size: 20px;
  }

  .specs {
    margin-top: 34px;
  }

  .specs > div {
    min-height: 48px;
    font-size: 8px;
    letter-spacing: .07em;
  }

  .specs strong {
    max-width: 145px;
  }

  .buy-button {
    min-height: 54px;
    font-size: 11px;
  }

  .fineprint {
    font-size: 9px;
  }

  
  .lookbook-section {
    padding-bottom: 96px;
  }

  .lookbook-heading {
    width: calc(100% - 28px);
    margin-bottom: 18px;
  }

  .lookbook-viewport {
    min-height: 500px;
    position: relative;
  }

  .lookbook-grid {
    position: relative;
    width: 100%;
    height: 500px;
    display: block;
  }

  .lookbook-card {
    position: absolute;
    top: 24px;
    left: 50%;
    width: min(84vw, 360px);
    height: 440px;
    margin: 0;
    transform: translateX(-50%) translateY(10px) scale(.992);
  }

  .lookbook-card:nth-child(1) {
    animation: lookbookLeftMobile 8s ease-in-out infinite;
  }

  .lookbook-card:nth-child(2) {
    animation: lookbookMiddleMobile 8s ease-in-out infinite;
  }

  .lookbook-card:nth-child(3) {
    animation: lookbookRightMobile 8s ease-in-out infinite;
  }

  @keyframes lookbookLeftMobile {
    0%, 4% {
      opacity: 0;
      transform: translateX(-50%) translateY(10px) scale(.992);
    }

    5%, 27% {
      opacity: 1;
      transform: translateX(-50%) translateY(0) scale(1);
    }

    28%, 100% {
      opacity: 0;
      transform: translateX(-50%) translateY(-8px) scale(.992);
    }
  }

  @keyframes lookbookMiddleMobile {
    0%, 25% {
      opacity: 0;
      transform: translateX(-50%) translateY(10px) scale(.992);
    }

    26%, 48% {
      opacity: 1;
      transform: translateX(-50%) translateY(0) scale(1);
    }

    49%, 100% {
      opacity: 0;
      transform: translateX(-50%) translateY(-8px) scale(.992);
    }
  }

  @keyframes lookbookRightMobile {
    0%, 46% {
      opacity: 0;
      transform: translateX(-50%) translateY(10px) scale(.992);
    }

    47%, 69% {
      opacity: 1;
      transform: translateX(-50%) translateY(0) scale(1);
    }

    70%, 100% {
      opacity: 0;
      transform: translateX(-50%) translateY(-8px) scale(.992);
    }
  }

  .lookbook-card:hover {
    transform: translateX(-50%) scale(1.02) !important;
  }

  .statement-section {
    padding: 0 14px 92px;
  }

  .statement {
    min-height: auto;
  }

  .statement-panel {
    min-height: 285px;
    padding: 46px 18px;
  }

  .statement h3 {
    font-size: 54px;
  }

  .typewriter-shell {
    min-height: 250px;
  }

  .typewriter-text {
    font-size: 16px;
    line-height: 1.58;
  }

  .inline-pregame-wordmark {
    height: 23px;
    margin: 0 4px;
    vertical-align: -6px;
  }

  .statement-wordmark {
    width: min(78vw, 280px);
    margin-top: 20px;
  }

  .shipping-note {
    font-size: 9px;
  }

  .footer {
    min-height: 170px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 20px;
    padding: 28px 16px;
    font-size: 9px;
    text-align: center;
  }

  .footer img {
    width: 28px;
    height: 28px;
  }

  .footer-links {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 18px;
  }

  .footer-links a,
  .footer-link-button {
    min-height: 44px;
    display: inline-flex;
    align-items: center;
  }

  .footer > span {
    justify-self: auto;
  }

  .legal-overlay {
    padding: 0;
    align-items: end;
  }

  .legal-dialog {
    width: 100%;
    max-height: 92svh;
    padding: 24px 18px 36px;
    border-left: 0;
    border-right: 0;
    border-bottom: 0;
  }

  .legal-close {
    width: 46px;
    height: 46px;
  }

  .legal-dialog h4 {
    font-size: 46px;
  }

  .legal-dialog h5 {
    font-size: 17px;
  }

  .legal-dialog p,
  .legal-dialog li {
    font-size: 14px;
  }

  .legal-placeholder {
    font-size: 10px;
  }

  .toast {
    left: 14px;
    right: 14px;
    bottom: 14px;
    text-align: center;
    font-size: 10px;
  }
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    scroll-behavior: auto !important;
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
`;

function useLoopingTypewriterProgress(
  totalLength: number,
  enabled = true,
  typingSpeed = 36,
  pauseAfterComplete = 2200
) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const reducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    if (reducedMotion) {
      setProgress(totalLength);
      return;
    }

    if (!enabled) {
      setProgress(0);
      return;
    }

    let characterIndex = 0;
    let timer: number | undefined;
    let cancelled = false;

    const typeNextCharacter = () => {
      if (cancelled) return;

      if (characterIndex <= totalLength) {
        setProgress(characterIndex);
        characterIndex += 1;

        timer = window.setTimeout(typeNextCharacter, typingSpeed);

        return;
      }

      timer = window.setTimeout(() => {
        if (cancelled) return;

        characterIndex = 0;
        setProgress(0);

        timer = window.setTimeout(typeNextCharacter, 400);
      }, pauseAfterComplete);
    };

    typeNextCharacter();

    return () => {
      cancelled = true;

      if (timer) {
        window.clearTimeout(timer);
      }
    };
  }, [totalLength, enabled, typingSpeed, pauseAfterComplete]);

  return progress;
}

export default function App() {
  const [frame, setFrame] = useState(0);
  const [hovering, setHovering] = useState(false);
  const [dragging, setDragging] = useState(false);
  const [toast, setToast] = useState("");
  const [loadingCheckout, setLoadingCheckout] = useState(false);
  const [legalPanel, setLegalPanel] = useState<LegalPanel>(null);
  const [aboutVisible, setAboutVisible] = useState(false);

  const siteRef = useRef<HTMLDivElement | null>(null);
  const heroRef = useRef<HTMLElement | null>(null);
  const aboutRef = useRef<HTMLElement | null>(null);

  const detailTypingProgress = useLoopingTypewriterProgress(
    detailTypingLength,
    aboutVisible
  );

  const typedDetailPartOne = detailPartOne.slice(
    0,
    Math.min(detailTypingProgress, detailPartOne.length)
  );

  const firstWordmarkPoint = detailPartOne.length;
  const showFirstInlineWordmark = detailTypingProgress > firstWordmarkPoint;

  const partTwoStart = firstWordmarkPoint;
  const partTwoProgress = Math.max(0, detailTypingProgress - partTwoStart);
  const typedDetailPartTwo = detailPartTwo.slice(
    0,
    Math.min(partTwoProgress, detailPartTwo.length)
  );

  const secondWordmarkPoint = partTwoStart + detailPartTwo.length;
  const showSecondInlineWordmark =
    detailTypingProgress > secondWordmarkPoint;

  const partThreeStart = secondWordmarkPoint + 1;
  const partThreeProgress = Math.max(0, detailTypingProgress - partThreeStart);
  const typedDetailPartThree = detailPartThree.slice(0, partThreeProgress);

  const viewerRef = useRef<HTMLDivElement | null>(null);

  const touchStartX = useRef<number | null>(null);

  const touchStartFrame = useRef(0);

  const toastTimer = useRef<number | null>(null);

  useEffect(() => {
    if (typeof window === "undefined" || !window.location) return;
    const params = new URLSearchParams(window.location.search);
    if (params.get("success") === "true") {
      showToast("THANK YOU FOR YOUR ORDER. CONFIRMATION SENT VIA EMAIL.");
      window.history.replaceState({}, document.title, window.location.pathname);
    } else if (params.get("canceled") === "true") {
      showToast("ORDER CANCELED. YOU CAN CHECKOUT ANYTIME.");
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  useEffect(() => {
    frames.forEach(({ src }) => {
      const image = new Image();
      image.src = src;
    });
  }, []);

  useEffect(() => {
    const reducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    if (reducedMotion) return;

    const timer = window.setInterval(() => {
      if (!hovering && !dragging && document.visibilityState === "visible") {
        setFrame((current) => (current + 1) % frames.length);
      }
    }, 1450);

    return () => window.clearInterval(timer);
  }, [hovering, dragging]);

  useEffect(() => {
    return () => {
      if (toastTimer.current) {
        window.clearTimeout(toastTimer.current);
      }
    };
  }, []);

  useEffect(() => {
    if (!legalPanel) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setLegalPanel(null);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [legalPanel]);

  useEffect(() => {
    const site = siteRef.current;
    const hero = heroRef.current;

    if (!site || !hero) return;

    let raf = 0;

    const updateHeroProgress = () => {
      raf = 0;

      const heroHeight = Math.max(hero.offsetHeight - window.innerHeight, 1);
      const progress = Math.max(
        0,
        Math.min(1, window.scrollY / heroHeight)
      );

      site.style.setProperty("--hero-progress", progress.toFixed(4));
    };

    const onScroll = () => {
      if (!raf) {
        raf = window.requestAnimationFrame(updateHeroProgress);
      }
    };

    updateHeroProgress();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);

      if (raf) {
        window.cancelAnimationFrame(raf);
      }
    };
  }, []);

  useEffect(() => {
    const reducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    const revealNodes = Array.from(
      document.querySelectorAll<HTMLElement>("[data-reveal]")
    );

    if (reducedMotion) {
      revealNodes.forEach((node) => node.classList.add("is-visible"));
      setAboutVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const node = entry.target as HTMLElement;

          if (entry.isIntersecting) {
            node.classList.add("is-visible");
          } else {
            node.classList.remove("is-visible");
          }
        });
      },
      {
        threshold: 0.18,
        rootMargin: "-4% 0px -10% 0px",
      }
    );

    revealNodes.forEach((node) => observer.observe(node));

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const about = aboutRef.current;

    if (!about) return;

    const reducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    if (reducedMotion) {
      setAboutVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setAboutVisible(entry.isIntersecting);
      },
      {
        threshold: 0.34,
      }
    );

    observer.observe(about);

    return () => observer.disconnect();
  }, []);

  const setFrameFromPointer = (clientX: number) => {
    const viewer = viewerRef.current;

    if (!viewer) return;

    const rect = viewer.getBoundingClientRect();

    const normalized = Math.max(
      0,
      Math.min(0.9999, (clientX - rect.left) / rect.width)
    );

    setFrame(Math.floor(normalized * frames.length));
  };

  const showToast = (message: string) => {
    setToast(message);

    if (toastTimer.current) {
      window.clearTimeout(toastTimer.current);
    }

    toastTimer.current = window.setTimeout(() => {
      setToast("");
    }, 2400);
  };

  const handleCheckout = async () => {
    if (loadingCheckout) return;
    setLoadingCheckout(true);
    try {
      const endpoints = [
        process.env.REACT_APP_API_URL
          ? `${process.env.REACT_APP_API_URL}/api/create-checkout-session`
          : null,
        "/api/create-checkout-session",
        "http://localhost:4242/api/create-checkout-session",
        "http://127.0.0.1:4242/api/create-checkout-session",
      ].filter(Boolean) as string[];

      let response: Response | null = null;

      for (const endpoint of endpoints) {
        try {
          const res = await fetch(endpoint, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              quantity: 1,
            }),
          });

          if (res.ok) {
            response = res;
            break;
          }
        } catch {
          continue;
        }
      }

      if (!response) {
        throw new Error("Unable to connect to checkout service");
      }

      const data = await response.json();

      if (data.url) {
        window.location.href = data.url;
      } else {
        throw new Error(data.error || "No checkout URL returned");
      }
    } catch {
      showToast("CHECKOUT TEMPORARILY UNAVAILABLE. PLEASE TRY AGAIN.");
      setLoadingCheckout(false);
    }
  };

  return (
    <div className="site" ref={siteRef}>
      <style>{styles}</style>

      <header className="header">
        <a className="turtle-home" href="#top" aria-label="PREGAME home">
          <img src="/assets/turtle-mark.png" alt="" />
        </a>

        <nav className="nav mono" aria-label="Main navigation">
          <a href="#cap">HEADWEAR</a>

          <a href="#details">ABOUT US</a>
        </nav>
      </header>

      <main>
        <section className="hero" id="top" ref={heroRef}>
          <div className="hero-content">
            <p className="micro mono hero-location">
              EST. 2025 · DARMSTADT, GERMANY
            </p>

            <div className="hero-brand-stage" aria-label="PREGAME">
              <img
                className="hero-turtle-large"
                src="/assets/turtle-mark.png"
                alt="PREGAME turtle"
              />

              <img
                className="wordmark"
                src="/assets/pregame-wordmark.png"
                alt="PREGAME"
              />
            </div>

            <p className="micro mono tagline">THE PLAN WAS, JUST ONE DRINK.</p>

            <a className="primary-button" href="#cap">
              SHOP HEADWEAR ↓
            </a>
          </div>

          <div className="ticker" aria-hidden="true">
            <div className="ticker-track">
              <div className="ticker-group">
                <span>PREGAME HEADWEAR 01 · €29.99 + SHIPPING · WEAR THE FIRST HEADWEAR ·</span>
                <span>PREGAME HEADWEAR 01 · €29.99 + SHIPPING · WEAR THE FIRST HEADWEAR ·</span>
                <span>PREGAME HEADWEAR 01 · €29.99 + SHIPPING · WEAR THE FIRST HEADWEAR ·</span>
              </div>

              <div className="ticker-group">
                <span>PREGAME HEADWEAR 01 · €29.99 + SHIPPING · WEAR THE FIRST HEADWEAR ·</span>
                <span>PREGAME HEADWEAR 01 · €29.99 + SHIPPING · WEAR THE FIRST HEADWEAR ·</span>
                <span>PREGAME HEADWEAR 01 · €29.99 + SHIPPING · WEAR THE FIRST HEADWEAR ·</span>
              </div>
            </div>
          </div>
        </section>

        <section className="product-section" id="cap">
          <div className="shell">
            <div className="section-title reveal reveal-left" data-reveal>
              <p className="micro mono">MERCH</p>

              <h1>
                Wear the first
                <br />
                PREGAME Headwear.
              </h1>
            </div>

            <div className="product-grid assemble" data-reveal>
              <div
                className="viewer reveal reveal-left reveal-delay-1"
                data-reveal
                ref={viewerRef}
                tabIndex={0}
                role="img"
                aria-label="Interactive PREGAME Headwear 01 view. Move left and right to rotate."
                onPointerEnter={(event) => {
                  setHovering(true);

                  if (event.pointerType === "mouse") {
                    setFrameFromPointer(event.clientX);
                  }
                }}
                onPointerLeave={() => {
                  setHovering(false);
                  setDragging(false);
                  touchStartX.current = null;
                }}
                onPointerMove={(event) => {
                  if (event.pointerType === "mouse") {
                    setFrameFromPointer(event.clientX);
                  } else if (dragging && touchStartX.current !== null) {
                    const delta = event.clientX - touchStartX.current;

                    const shift = Math.round(delta / 72);

                    const next =
                      (touchStartFrame.current - shift + frames.length * 10) %
                      frames.length;

                    setFrame(next);
                  }
                }}
                onPointerDown={(event) => {
                  if (event.pointerType !== "mouse") {
                    setDragging(true);

                    touchStartX.current = event.clientX;

                    touchStartFrame.current = frame;

                    event.currentTarget.setPointerCapture(event.pointerId);
                  }
                }}
                onPointerUp={(event) => {
                  setDragging(false);

                  touchStartX.current = null;

                  if (event.currentTarget.hasPointerCapture(event.pointerId)) {
                    event.currentTarget.releasePointerCapture(event.pointerId);
                  }
                }}
                onPointerCancel={() => {
                  setDragging(false);
                  touchStartX.current = null;
                }}
                onKeyDown={(event) => {
                  if (event.key === "ArrowLeft") {
                    setFrame(
                      (current) => (current - 1 + frames.length) % frames.length
                    );
                  }

                  if (event.key === "ArrowRight") {
                    setFrame((current) => (current + 1) % frames.length);
                  }
                }}
              >
                <div className="viewer-bar">
                  <span>PREGAME Headwear 01</span>

                  <span>INTERACTIVE VIEW</span>
                </div>

                <div className="cap-stage">
                  <img
                    key={frames[frame].src}
                    className="cap-image"
                    src={frames[frame].src}
                    alt={`PREGAME Headwear 01 ${frames[
                      frame
                    ].label.toLowerCase()} view`}
                    draggable={false}
                  />
                </div>

                <div className="viewer-bar">
                  <span>{frames[frame].label}</span>

                  <span>MOVE / SWIPE LEFT + RIGHT</span>
                </div>
              </div>

              <aside className="purchase reveal reveal-right reveal-delay-2" data-reveal>
                <p className="micro mono">DROP 001</p>

                <h2>PREGAME Headwear 01</h2>

                <p className="price">€29.99</p>

                <p className="shipping-note">+ SHIPPING</p>

                <div className="specs">
                  <div>
                    <span>COLOR</span>

                    <strong>BLACK</strong>
                  </div>

                  <div>
                    <span>FRONT</span>

                    <strong>WHITE PREGAME EMBROIDERY</strong>
                  </div>

                  <div>
                    <span>SIDE</span>

                    <strong>TURTLE DETAIL</strong>
                  </div>

                  <div>
                    <span>FIT</span>

                    <strong>ADJUSTABLE</strong>
                  </div>
                </div>

                <button
                  className="buy-button"
                  type="button"
                  onClick={handleCheckout}
                  disabled={loadingCheckout}
                >
                  <span>{loadingCheckout ? "CONNECTING..." : "BUY HEADWEAR"}</span>

                  <span>€29.99</span>
                </button>

                <p className="fineprint">
                  SHIPPING IS CALCULATED AT CHECKOUT.
                </p>
              </aside>
            </div>
          </div>
        </section>

        <section
          className="lookbook-section reveal reveal-up"
          data-reveal
          aria-label="PREGAME Headwear 01 lookbook"
        >
          <div className="lookbook-heading reveal reveal-left" data-reveal>
            <p className="micro mono">LOOKBOOK</p>
          </div>

          <div className="lookbook-viewport">
            <div className="lookbook-grid">
              {lifestyleImages.map((image, index) => (
                <figure
                  className={`lookbook-card reveal ${
                    index % 2 === 0 ? "reveal-left" : "reveal-right"
                  } reveal-delay-${Math.min(index + 1, 4)}`}
                  data-reveal
                  key={image}
                >
                  <img
                    src={image}
                    alt={`PREGAME Headwear 01 lookbook ${index + 1}`}
                    loading="lazy"
                  />
                </figure>
              ))}
            </div>
          </div>
        </section>

        <section className="statement-section reveal reveal-up" id="details" ref={aboutRef} data-reveal>
          <div className="shell statement">
            <div className="statement-panel reveal reveal-left reveal-delay-1" data-reveal>
              <h3>Be a part of</h3>

              <img
                className="statement-wordmark"
                src="/assets/pregame-wordmark.png"
                alt="PREGAME"
              />
            </div>

            <div className="statement-panel reveal reveal-right reveal-delay-2" data-reveal>
              <div className="typewriter-shell">
                <p className="typewriter-text">
                  <span>{typedDetailPartOne}</span>

                  {showFirstInlineWordmark && (
                    <span>{typedDetailPartTwo}</span>
                  )}

                  {showSecondInlineWordmark && (
                    <img
                      className="inline-pregame-wordmark"
                      src="/assets/pregame-wordmark.png"
                      alt="PREGAME"
                    />
                  )}

                  {showSecondInlineWordmark && (
                    <span>{typedDetailPartThree}</span>
                  )}

                  <span className="typewriter-cursor" aria-hidden="true" />
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="footer">
        <img src="/assets/turtle-mark.png" alt="" />

        <div className="footer-links">
          <a
            href="https://www.instagram.com/pregame.da/?utm_source=ig_web_button_share_sheet"
            target="_blank"
            rel="noopener noreferrer"
          >
            INSTAGRAM
          </a>

          <button
            className="footer-link-button"
            type="button"
            onClick={() => setLegalPanel("legal")}
          >
            LEGAL
          </button>

          <button
            className="footer-link-button"
            type="button"
            onClick={() => setLegalPanel("privacy")}
          >
            PRIVACY
          </button>
        </div>

        <span>© 2026 PREGAME. ALL RIGHTS RESERVED.</span>
      </footer>

      {legalPanel && (
        <div
          className="legal-overlay"
          role="presentation"
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) {
              setLegalPanel(null);
            }
          }}
        >
          <section
            className="legal-dialog"
            role="dialog"
            aria-modal="true"
            aria-label={
              legalPanel === "legal" ? "Legal Notice" : "Privacy Policy"
            }
          >
            <button
              className="legal-close"
              type="button"
              aria-label="Close"
              onClick={() => setLegalPanel(null)}
            >
              ×
            </button>

                        {legalPanel === "legal" ? (
              <>
                <p className="micro mono legal-kicker">
                  LEGAL NOTICE / IMPRESSUM
                </p>

                <h4>
                  Legal
                  <br />
                  Notice.
                </h4>

                <p>
                  Information pursuant to Section 5 of the German Digital
                  Services Act (Digitale-Dienste-Gesetz — DDG).
                </p>

                <div className="legal-placeholder">
                  PREGAME EVENT GBR
                  <br />
                  ALICENSTRASSE 18
                  <br />
                  64293 DARMSTADT
                  <br />
                  GERMANY
                  <br />
                  <br />
                  REPRESENTED BY THE AUTHORIZED PARTNERS:
                  <br />
                  JEAN SCHÖFFEL
                  <br />
                  JOSHUA OBENG-MANU
                  <br />
                  NICOLAS ACHILLEAS JACOBI
                  <br />
                  <br />
                  CONTACT:
                  <br />
                  EMAIL: CONNECT@PREGAME.FAMILY
                </div>

                <h5>Value Added Tax (Umsatzsteuer)</h5>
                <p>
                  Due to the small business status pursuant to § 19 UStG (German
                  Value Added Tax Act), value added tax is not charged or
                  displayed separately.
                </p>

                <h5>Online Dispute Resolution (EU Regulation)</h5>
                <p>
                  The European Commission provides a platform for online dispute
                  resolution (ODR):{" "}
                  <a
                    href="https://ec.europa.eu/consumers/odr"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "underline" }}
                  >
                    https://ec.europa.eu/consumers/odr
                  </a>
                  . Our email address can be found above in the legal notice.
                </p>

                <h5>Consumer Dispute Resolution (VSBG)</h5>
                <p>
                  We are neither willing nor obliged to participate in dispute
                  resolution proceedings before a consumer arbitration board
                  pursuant to Section 36 of the German Consumer Dispute
                  Resolution Act (Verbraucherstreitbeilegungsgesetz — VSBG).
                </p>

                <h5>Right of Withdrawal for Consumers (Widerrufsbelehrung)</h5>
                <p>
                  Consumers residing in the European Union have a statutory right
                  of withdrawal of 14 days starting from the day on which they or
                  a designated third party (other than the carrier) have received
                  physical possession of the goods. To exercise this right, you
                  may inform us by email at{" "}
                  <strong>connect@pregame.family</strong>.
                </p>

                <h5>Statutory Warranty (Gewährleistung)</h5>
                <p>
                  Statutory warranty rights pursuant to the provisions of the
                  German Civil Code (BGB) apply to all purchased merchandise.
                </p>

                <h5>Liability for Content</h5>
                <p>
                  As a service provider, we are responsible for our own content
                  on these web pages pursuant to § 7 (1) DDG under general
                  statutory laws. According to §§ 8 to 10 DDG, however, we are
                  not obliged to monitor transmitted or stored external
                  information or to investigate circumstances that indicate
                  illegal activity.
                </p>

                <h5>Liability for External Links</h5>
                <p>
                  Our website contains links to external third-party websites
                  (such as Instagram) over whose content we have no influence.
                  Therefore, we cannot assume any liability for such external
                  content. The respective provider or operator of the linked
                  pages is always responsible for their contents.
                </p>

                <h5>Copyright Notice</h5>
                <p>
                  The content, designs, photography, brand names and works
                  published on this website are protected under German and
                  international copyright laws. Any reproduction, processing,
                  distribution or form of commercialization requires prior
                  written consent.
                </p>
              </>
            ) : (
              <>
                <p className="micro mono legal-kicker">
                  PRIVACY POLICY / DATENSCHUTZERKLÄRUNG
                </p>

                <h4>
                  Privacy
                  <br />
                  Policy.
                </h4>

                <h5>1. Controller (Verantwortlicher)</h5>
                <p>
                  The controller responsible for data processing on this website
                  within the meaning of the General Data Protection Regulation
                  (GDPR / DSGVO) is:
                </p>

                <div className="legal-placeholder">
                  PREGAME EVENT GBR
                  <br />
                  ALICENSTRASSE 18
                  <br />
                  64293 DARMSTADT
                  <br />
                  GERMANY
                  <br />
                  <br />
                  REPRESENTED BY:
                  <br />
                  JEAN SCHÖFFEL
                  <br />
                  JOSHUA OBENG-MANU
                  <br />
                  NICOLAS ACHILLEAS JACOBI
                  <br />
                  <br />
                  PRIVACY CONTACT:
                  <br />
                  CONNECT@PREGAME.FAMILY
                </div>

                <h5>2. Hosting & Infrastructure (Firebase App Hosting)</h5>
                <p>
                  This website is hosted via Google Firebase App Hosting and
                  Google Cloud Platform, provided by Google Ireland Limited,
                  Gordon House, Barrow Street, Dublin 4, Ireland.
                </p>
                <p>
                  When you visit our website, server access logs (including your
                  IP address, date and time of request, accessed URL, browser
                  type, operating system, and HTTP status code) are automatically
                  processed by Google Cloud infrastructure to ensure secure,
                  reliable, and performant delivery of our pages.
                </p>
                <p>
                  The legal basis for this data processing is Art. 6(1)(f) GDPR
                  (our legitimate interest in the technically flawless and
                  secure operation of the website). Standard Contractual Clauses
                  (SCC) and Data Processing Agreements (DPA) are concluded with
                  Google to safeguard data protection compliance.
                </p>

                <h5>3. Online Orders & Stripe Payment Processing</h5>
                <p>
                  When you initiate a purchase on our website, checkout session
                  and payment processing is securely handled by our payment
                  service provider:
                </p>
                <p>
                  <strong>Stripe Payments Europe, Ltd.</strong>, 1 Grand Canal
                  Street Lower, Grand Canal Dock, Dublin, D02 H210, Ireland.
                </p>
                <p>
                  During the checkout process, Stripe processes the personal
                  information you provide, including your name, shipping address,
                  billing address, email address, telephone number, payment
                  method details (credit/debit card, Apple Pay, Google Pay, Link,
                  or Klarna), purchase items, and transaction metadata.
                </p>
                <p>
                  The legal basis for processing this data is Art. 6(1)(b) GDPR
                  (performance of a purchase contract and pre-contractual steps)
                  and Art. 6(1)(c) GDPR (compliance with statutory commercial and
                  tax retention obligations). Stripe is certified under PCI-DSS
                  Level 1 and complies with the EU-U.S. Data Privacy Framework.
                </p>

                <h5>4. Cookies & Local Storage</h5>
                <p>
                  We prioritize user privacy: our website does not utilize
                  third-party tracking cookies, behavioral analytics, or
                  marketing pixels.
                </p>
                <p>
                  Only strictly technically necessary cookies or temporary
                  session tokens required for checkout security and core site
                  functionality are utilized pursuant to Section 25 (2) No. 2
                  TDDDG (Telecommunications Digital Services Data Protection Act)
                  and Art. 6(1)(f) GDPR.
                </p>

                <h5>5. External Links (Instagram)</h5>
                <p>
                  Our website includes regular hyperlinks to our official
                  Instagram profile (@pregame.da). We do not embed active Meta
                  tracking pixels, social plugins or iframes. Data is only
                  transmitted to Meta Platforms Ireland Ltd. when you actively
                  click on the external link.
                </p>

                <h5>6. Data Retention Period</h5>
                <p>
                  Personal data collected in connection with orders and invoices
                  is stored in accordance with statutory retention periods under
                  German commercial and tax law (pursuant to § 257 HGB and § 147
                  AO, typically up to 10 years). Technical access logs are
                  automatically rotated and deleted.
                </p>

                <h5>7. Your Data Subject Rights</h5>
                <p>
                  Under the General Data Protection Regulation (GDPR), you
                  possess the following statutory rights regarding your personal
                  data:
                </p>
                <ul>
                  <li>Right to information / access (Art. 15 GDPR)</li>
                  <li>Right to rectification (Art. 16 GDPR)</li>
                  <li>Right to erasure / Right to be forgotten (Art. 17 GDPR)</li>
                  <li>Right to restriction of processing (Art. 18 GDPR)</li>
                  <li>Right to data portability (Art. 20 GDPR)</li>
                  <li>Right to object to processing (Art. 21 GDPR)</li>
                  <li>
                    Right to lodge a complaint with a competent data protection
                    supervisory authority (Art. 77 GDPR), such as:{" "}
                    <em>
                      Der Hessische Beauftragte für Datenschutz und
                      Informationsfreiheit, Gustav-Stresemann-Ring 1, 65189
                      Wiesbaden, Germany
                    </em>
                    .
                  </li>
                </ul>

                <h5>8. Contact for Data Protection Matters</h5>
                <p>
                  If you have questions about the collection, processing, or use
                  of your personal data or wish to assert your rights, please
                  contact us at <strong>connect@pregame.family</strong>.
                </p>
              </>
            )}
          </section>
        </div>
      )}

      <div
        className={`toast ${toast ? "visible" : ""}`}
        role="status"
        aria-live="polite"
      >
        {toast}
      </div>
    </div>
  );
}